import CriminalHistoryDisclosureView from "./CriminalHistoryDisclosureView";

export default CriminalHistoryDisclosureView;
